module.exports = __webpack_public_path__ + "img/js-square-brands.eb9195a8.svg";